// extracted by mini-css-extract-plugin
export default {"container":"CompaniesField_container__E8C+z"};